import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Label } from 'Components/frameworks/formik/formik-input/Label';
import { getInputClasses } from 'Components/frameworks/formik/inputsUtils';
import { ErrorNote } from 'Components/frameworks/formik/formik-input/ErrorNote';
type Props = {
  label: string;
  id?: string;
  small?: boolean;
  children?: ReactNode;
  hasError?: boolean;
  errorMessage?: string;
  isValid?: boolean;
  container?: boolean;
  isRequired?: boolean;
  type?: string;
  name?: string;
  className?: string;
};
export const HostedField = ({
  label,
  id = '',
  small = false,
  children,
  hasError = false,
  errorMessage,
  isValid = false,
  isRequired = false,
  container = true,
}: Props) => {
  const classes = getInputClasses({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: !hasError && !isValid,
    isErrored: hasError,
    isValidated: isValid,
  });
  return (
    <div
      className={classnames('w-full px-10 pb-10 pt-20', {
        'basis-full': !small,
        'basis-1/2': small,
      })}
    >
      <Label
        className="mx-15 mb-5"
        htmlFor={id}
        isErrored={hasError}
        isRequired={isRequired}
        label={label}
      />
      <div
        className={classnames(container ? classes : {}, {
          'border-red': hasError,
          'border-success': isValid,
        })}
        id={id}
      >
        {children}
      </div>
      {hasError && errorMessage && (
        <ErrorNote className="mx-15" isErrored errorMessage={errorMessage} />
      )}
    </div>
  );
};
